import { Injectable, Optional } from "@angular/core";
import { SERVER_API_URL } from "../../app.constants";
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
} from "@angular/common/http";
import { Observable } from "rxjs/internal/Observable";
import * as Sentry from "@sentry/browser";
import {
  OAuthModuleConfig,
  OAuthResourceServerErrorHandler,
  OAuthStorage,
} from "angular-oauth2-oidc";
import { ACCESS_TOKEN_KEY } from "../user/user.service";

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(
    private authStorage: OAuthStorage,
    @Optional() private moduleConfig: OAuthModuleConfig
  ) {}

  private checkUrl(url: string): boolean {
    let found = this.moduleConfig.resourceServer.allowedUrls.find((u) =>
      url.startsWith(u)
    );
    return !!found;
  }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (
      !request ||
      !request.url ||
      !(SERVER_API_URL && request.url.startsWith(SERVER_API_URL))
    ) {
      return next.handle(request);
    }

    //let url = request.url.toLowerCase();

    if (!this.moduleConfig) return next.handle(request);
    if (!this.moduleConfig.resourceServer) return next.handle(request);
    //if (!this.moduleConfig.resourceServer.allowedUrls) return next.handle(request);
    //if (!this.checkUrl(url)) return next.handle(request);

    let sendAccessToken = this.moduleConfig.resourceServer.sendAccessToken;

    //add sentry transaction Id for each request
    const transactionId = Math.random().toString(36).substr(2, 9);
    Sentry.setTag("transaction_id", transactionId);

    if (sendAccessToken) {
      let token = this.authStorage.getItem(ACCESS_TOKEN_KEY);
      let tokenHeader = "Bearer " + token;

      if (token) {
        request = request.clone({
          setHeaders: {
            "X-Sentry-Transaction-ID": transactionId,
            Authorization: tokenHeader,
          },
        });
      }
    }

    return next.handle(request);
  }
}
